/* eslint-disable */
import React, { useState, useEffect, useMemo, useCallback, useRef } from "react";
import { DEVICE_DB, SZ_PRESETS, BROWSERS, NETWORKS, TOUCH_MODES, DEFAULT_DEV } from "./SimulatorDevices";

import { API_BASE } from "../config/apiConfig";

// ── ERP Enterprise CSS Styles ──────────────────────────────────────────────────
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Inter:wght@400;500;600;700&display=swap');

.erp-ds {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 70px);
  background-color: #f8fafc;
  color: #0f172a;
  font-family: 'Outfit', 'Inter', -apple-system, sans-serif;
  overflow: hidden;
  user-select: none;
}

/* ERP Top Header & Navigation Bar */
.erp-top {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 18px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.03);
  flex-shrink: 0;
  overflow-x: auto;
  z-index: 20;
}
.erp-top::-webkit-scrollbar { height: 4px; }
.erp-top::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

.erp-title {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 16px;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.3px;
  white-space: nowrap;
}
.erp-title-badge {
  background: #FD6101;
  color: #ffffff;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.erp-url-box {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #f1f5f9;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  padding: 6px 12px;
  flex: 1;
  max-width: 460px;
  min-width: 220px;
  transition: all 0.2s ease;
}
.erp-url-box:focus-within {
  background: #ffffff;
  border-color: #FD6101;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.12);
}
.erp-url-input {
  background: transparent;
  border: none;
  color: #0f172a;
  font-size: 12.5px;
  font-weight: 500;
  outline: none;
  flex: 1;
  min-width: 0;
  font-family: inherit;
}
.erp-url-input::placeholder { color: #94a3b8; }

.erp-sep {
  width: 1px;
  height: 22px;
  background: #e2e8f0;
  flex-shrink: 0;
}

/* Button & Tool Styles */
.erp-btn {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  white-space: nowrap;
  font-family: inherit;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.erp-btn:hover {
  background: #f8fafc;
  border-color: #FD6101;
  color: #FD6101;
  transform: translateY(-1px);
}
.erp-btn.active {
  background: #FD6101;
  border-color: #FD6101;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(253, 97, 1, 0.25);
}

.erp-btn-icon {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #475569;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.erp-btn-icon:hover {
  background: #FD6101;
  border-color: #FD6101;
  color: #ffffff;
  box-shadow: 0 4px 12px rgba(124, 58, 237, 0.2);
}

/* ERP Layout Panels */
.erp-main {
  display: flex;
  flex: 1;
  overflow: hidden;
  position: relative;
}

.erp-left-panel {
  width: 270px;
  min-width: 270px;
  background: #ffffff;
  border-right: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  flex-shrink: 0;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.02);
}
.erp-left-panel.closed { width: 0; min-width: 0; overflow: hidden; border-right: none; }

.erp-right-panel {
  width: 290px;
  min-width: 290px;
  background: #ffffff;
  border-left: 1px solid #e2e8f0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  flex-shrink: 0;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.02);
}
.erp-right-panel.closed { width: 0; min-width: 0; overflow: hidden; border-left: none; }

.erp-panel-title {
  padding: 12px 16px;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #64748b;
  border-bottom: 1px solid #f1f5f9;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f8fafc;
  flex-shrink: 0;
}

.erp-tabs {
  display: flex;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  flex-shrink: 0;
}
.erp-tab {
  flex: 1;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #64748b;
  padding: 10px 6px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.04em;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: inherit;
}
.erp-tab:hover { color: #0f172a; }
.erp-tab.active { color: #FD6101; border-bottom-color: #FD6101; }

.erp-scroll {
  overflow-y: auto;
  flex: 1;
  padding: 6px 0;
}
.erp-scroll::-webkit-scrollbar { width: 5px; }
.erp-scroll::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 4px; }

.erp-search {
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
  flex-shrink: 0;
}
.erp-search input {
  width: 100%;
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #0f172a;
  padding: 7px 12px;
  border-radius: 8px;
  font-size: 12px;
  outline: none;
  box-sizing: border-box;
  font-family: inherit;
  transition: all 0.2s ease;
}
.erp-search input:focus {
  background: #ffffff;
  border-color: #FD6101;
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.1);
}

/* Device Tree Items */
.erp-cat {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  cursor: pointer;
  font-size: 12.5px;
  font-weight: 700;
  color: #334155;
  transition: all 0.15s ease;
}
.erp-cat:hover { background: #f1f5f9; color: #FD6101; }
.erp-cat.open { color: #FD6101; }

.erp-brand {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 14px 8px 28px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  color: #475569;
  transition: all 0.15s ease;
}
.erp-brand:hover { background: #f8fafc; color: #0f172a; }
.erp-brand.open { color: #FD6101; font-weight: 700; }

.erp-dev-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 7px 14px 7px 44px;
  font-size: 12px;
  color: #475569;
  cursor: pointer;
  transition: all 0.15s ease;
}
.erp-dev-row:hover { background: #f1f5f9; color: #0f172a; }
.erp-dev-row.active {
  background: rgba(124, 58, 237, 0.08);
  color: #FD6101;
  font-weight: 700;
  border-left: 3px solid #FD6101;
}

/* Center Viewport Canvas */
.erp-center {
  flex: 1;
  background-color: #f1f5f9;
  background-image: radial-gradient(#cbd5e1 1.2px, transparent 1.2px);
  background-size: 20px 20px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
  position: relative;
}

.erp-sub-toolbar {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 18px;
  background: #ffffff;
  border-bottom: 1px solid #e2e8f0;
  flex-shrink: 0;
  overflow-x: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.02);
}

.erp-badge {
  background: #f1f5f9;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 6px;
  white-space: nowrap;
}
.erp-badge.purple { background: rgba(124, 58, 237, 0.08); border-color: rgba(124, 58, 237, 0.2); color: #FD6101; }
.erp-badge.green { background: rgba(34, 197, 94, 0.08); border-color: rgba(34, 197, 94, 0.2); color: #16a34a; }
.erp-badge.blue { background: rgba(59, 130, 246, 0.08); border-color: rgba(59, 130, 246, 0.2); color: FD6101; }

.erp-canvas {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow: hidden;
  position: relative;
}

/* Property Inspector Card Rules */
.erp-section-title {
  padding: 10px 14px 4px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-top: 6px;
}
.erp-prop-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 14px;
  border-bottom: 1px solid #f8fafc;
  font-size: 12px;
  gap: 10px;
}
.erp-prop-label { color: #64748b; font-weight: 500; }
.erp-prop-val { color: #0f172a; font-weight: 700; text-align: right; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 160px; }

/* Status Footer Bar */
.erp-status-bar {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 6px 18px;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
  font-size: 11px;
  font-weight: 600;
  color: #64748b;
  flex-shrink: 0;
  overflow-x: auto;
  white-space: nowrap;
}
.erp-status-item { display: flex; align-items: center; gap: 5px; }
.erp-status-dot { width: 7px; height: 7px; border-radius: 50%; }

/* DevTools Drawer */
.erp-devtools {
  height: 200px;
  background: #ffffff;
  border-top: 2px solid #FD6101;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.05);
}
.erp-dt-header {
  display: flex;
  align-items: center;
  padding: 0 12px;
  border-bottom: 1px solid #e2e8f0;
  background: #f8fafc;
  flex-shrink: 0;
}
.erp-dt-tab {
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: #64748b;
  padding: 8px 14px;
  font-size: 11.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
}
.erp-dt-tab.active { color: #FD6101; border-bottom-color: #FD6101; }
.erp-dt-content {
  flex: 1;
  overflow-y: auto;
  padding: 12px 16px;
  font-family: 'JetBrains Mono', 'Courier New', monospace;
  font-size: 11.5px;
  background: #0f172a;
  color: #e2e8f0;
}
`;

// ── Helpers ────────────────────────────────────────────────────────────────────
const allDevices = (() => {
  const r = [];
  Object.entries(DEVICE_DB).forEach(([cId, cat]) =>
    Object.entries(cat.brands).forEach(([brand, devs]) =>
      devs.forEach(d => r.push({ ...d, brand, category: cId }))
    )
  );
  return r;
})();

// ── Realistic Pixel-Perfect Device Frame Component ──────────────────────────────
function DeviceFrame({ dev, landscape, zoom, url, iframeKey, isMain, slotIdx, onBlocked, blocked, canvasW, canvasH, ...apkProps }) {
  const ls = (slotIdx === 0) ? landscape : false;
  const dW = ls ? dev.h : dev.w;
  const dH = ls ? dev.w : dev.h;
  const dType = dev.type || "mobile";
  const mob = !dev.type || dType === "mobile";
  const tab = dType === "tablet";
  const lap = dType === "laptop" || dType === "desktop";

  const {
    simMode,
    apkFile,
    apkInfo,
    apkInstallState,
    apkLaunchState,
    apkError,
    apkUrl,
    batteryLevel,
    gpsLoc,
    powerOn,
    camMock,
    micMock,
    appScreen,
    setAppScreen,
    addApkLog,
    installApk,
    launchApp,
    emuStatus,
    setLogcatOpen,
    API_BASE,
    healthCheck
  } = apkProps;

  // ── Fit-to-Canvas Scaling (no scroll ever) ───────────────────────────────────
  const slotCount = isMain ? 1 : 4; // multi-grid shows up to 4 frames
  const availW = isMain
    ? (canvasW || 500) - 48          // 24px padding each side
    : ((canvasW || 500) - 96) / 2;   // two columns with gaps
  const availH = (canvasH || 700) - 80; // 48px padding + 32px badge label

  const s = Math.min(availW / dW, availH / dH) * (zoom / 100);

  const fW = Math.round(dW * s);
  const fH = Math.round(dH * s);
  const radius = mob ? 42 : tab ? 24 : 12;
  const padTop = (dev.notch || dev.island) && mob ? Math.round(28 * s) : mob ? Math.round(14 * s) : tab ? Math.round(12 * s) : Math.round(8 * s);
  const padBot = mob ? Math.round(24 * s) : tab ? Math.round(14 * s) : 0;
  const padS = mob ? Math.round(12 * s) : tab ? Math.round(12 * s) : Math.round(6 * s);
  const totalW = fW + padS * 2;
  const totalH = fH + padTop + padBot;
  const iW = Math.max(54, Math.round(80 * s));
  const iH = Math.max(16, Math.round(24 * s));
  const nW = Math.max(90, Math.round(118 * s));

  const [simTime, setSimTime] = useState("9:41");
  useEffect(() => {
    const updateTime = () => {
      const now = new Date();
      setSimTime(now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }));
    };
    updateTime();
    const timer = setInterval(updateTime, 30000);
    return () => clearInterval(timer);
  }, []);

  const [frameSrc, setFrameSrc] = useState("");
  useEffect(() => {
    if (simMode !== "apk" || !emuStatus.booted || emuStatus.failed) return;
    let active = true;
    let loading = false;

    const loadNext = () => {
      if (!active || loading) return;
      loading = true;
      const img = new Image();
      img.onload = () => {
        if (active) {
          setFrameSrc(img.src);
          loading = false;
          setTimeout(loadNext, 120);
        }
      };
      img.onerror = () => {
        loading = false;
        if (active) {
          setTimeout(loadNext, 500);
        }
      };
      img.src = `${API_BASE}/api/mobile/stream?t=${Date.now()}`;
    };

    loadNext();
    return () => {
      active = false;
    };
  }, [simMode, emuStatus.booted, emuStatus.failed, API_BASE]);

  const handleScreenClick = (e) => {
    if (emuStatus.status_message !== "Application Running" && emuStatus.status_message !== "Live") return;
    const rect = e.target.getBoundingClientRect();
    const scaleX = 1080 / rect.width;
    const scaleY = 2160 / rect.height;
    const absX = Math.round((e.clientX - rect.left) * scaleX);
    const absY = Math.round((e.clientY - rect.top) * scaleY);

    fetch(`${API_BASE}/api/mobile/touch`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "tap", x: absX, y: absY })
    }).catch(err => console.error(err));
    addApkLog("I", "InputEvent", `Tap at coordinates (${absX}, ${absY})`);
  };

  const handleRetryEmu = () => {
    fetch(`${API_BASE}/api/emulator-restart`, { method: "POST" })
      .then(() => addApkLog("I", "System", "Emulator restart triggered"))
      .catch(err => console.error(err));
  };

  const handleRestartApp = () => {
    fetch(`${API_BASE}/api/mobile/restart`, { method: "POST" })
      .then(() => addApkLog("I", "System", "App restart triggered"))
      .catch(err => console.error(err));
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12, flexShrink: 0 }}>
      {/* Outer Hardware Chassis Frame */}
      <div className="device-chassis-frame" style={{
        width: totalW,
        height: totalH,
        borderRadius: radius,
        background: "#002247",
        border: "3.5px solid #334155",
        boxShadow: isMain
          ? "0 30px 70px -15px rgba(15, 23, 42, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.15), inset 0 0 12px rgba(0,0,0,0.6)"
          : "0 12px 30px rgba(0, 0, 0, 0.22)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        overflow: "visible",
        flexShrink: 0,
        transition: "all 0.35s cubic-bezier(0.4, 0, 0.2, 1)"
      }}>

        {/* Side Hardware Buttons */}
        {mob && !ls && (
          <>
            {/* Volume Up */}
            <div style={{ position: "absolute", left: -6, top: Math.round(75 * s), width: 3, height: Math.round(36 * s), background: "#475569", borderRadius: "3px 0 0 3px", boxShadow: "-1px 0 2px rgba(0,0,0,0.3)" }} />
            {/* Volume Down */}
            <div style={{ position: "absolute", left: -6, top: Math.round(120 * s), width: 3, height: Math.round(36 * s), background: "#475569", borderRadius: "3px 0 0 3px", boxShadow: "-1px 0 2px rgba(0,0,0,0.3)" }} />
            {/* Power Button */}
            <div style={{ position: "absolute", right: -6, top: Math.round(95 * s), width: 3, height: Math.round(48 * s), background: "#475569", borderRadius: "0 3px 3px 0", boxShadow: "1px 0 2px rgba(0,0,0,0.3)" }} />
          </>
        )}

        {/* Earpiece Speaker Grille */}
        {mob && (
          <div style={{ position: "absolute", top: Math.max(4, Math.round(5 * s)), left: "50%", transform: "translateX(-50%)", width: Math.round(45 * s), height: 3, background: "#334155", borderRadius: 2, zIndex: 12 }} />
        )}

        {/* Notch */}
        {dev.notch && mob && (
          <div style={{ position: "absolute", top: 0, left: "50%", transform: "translateX(-50%)", width: nW, height: padTop, background: "#0f172a", borderRadius: "0 0 16px 16px", zIndex: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <div style={{ width: 8, height: 8, borderRadius: "50%", background: "#000", border: "1px solid #334155" }} />
          </div>
        )}
        {/* Dynamic Island */}
        {dev.island && mob && (
          <div style={{ position: "absolute", top: Math.max(6, Math.round(7 * s)), left: "50%", transform: "translateX(-50%)", width: iW, height: iH, background: "#000", borderRadius: iH, zIndex: 11, border: "1px solid #1e293b", display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: 6 }}>
            <div style={{ width: 6, height: 6, borderRadius: "50%", background: "#0284c7" }} />
          </div>
        )}

        <div style={{ height: padTop, flexShrink: 0 }} />

        {/* Screen Display Area */}
        <div style={{ width: fW, height: fH, position: "relative", overflow: "hidden", borderRadius: mob ? 10 : 4, background: "#ffffff", flexShrink: 0, boxShadow: "inset 0 0 8px rgba(0,0,0,0.1)" }}>

          {/* Simulated Mobile Status Bar (Time, Battery, Wifi) */}
          {mob && !ls && (
            <div style={{
              height: 22,
              width: "100%",
              background: "#0f172a",
              color: "#ffffff",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              padding: "0 12px",
              fontSize: 10,
              fontWeight: 700,
              zIndex: 8,
              position: "relative",
              boxSizing: "border-box"
            }}>
              <span>{simTime}</span>
              <div style={{ display: "flex", alignItems: "center", gap: 6, fontSize: 9 }}>
                <span>5G</span>
                <span>📶</span>
                <span>🔋 {simMode === "apk" ? batteryLevel : "98"}%</span>
              </div>
            </div>
          )}

          {simMode === "apk" ? (
            <div style={{ width: "100%", height: mob && !ls ? "calc(100% - 22px)" : "100%", background: "#0f172a", position: "relative", display: "flex", flexDirection: "column", userSelect: "none" }}>
              {healthCheck ? (
                /* Setup Configuration Checklist Screen */
                <div style={{ flex: 1, display: "flex", flexDirection: "column", padding: "16px 20px", background: "#090d16", color: "#e2e8f0", overflowY: "auto" }}>
                  <div style={{ fontWeight: 800, fontSize: 14, color: "#ffffff", marginBottom: 8, textAlign: "center" }}>⚠️ System Checklist</div>
                  <div style={{ fontSize: 10.5, color: "#94a3b8", marginBottom: 14, textAlign: "center", lineHeight: 1.4 }}>
                    FastAPI backend is active, but essential Android SDK platform tools or AVD config is missing.
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 9, marginBottom: 16 }}>
                    {[
                      { label: "Python Backend Running", ok: healthCheck.python_running },
                      { label: "FastAPI Service Running", ok: healthCheck.fastapi_running },
                      { label: "Android SDK Installed", ok: healthCheck.android_sdk_installed },
                      { label: "ADB Utility Path Available", ok: healthCheck.adb_found },
                      { label: "AVD Emulator Image Found", ok: healthCheck.emulator_image_found },
                      { label: "PostgreSQL Pool Connected", ok: healthCheck.postgresql_connected },
                      { label: "WebRTC Streaming Interface", ok: healthCheck.webrtc_service_available },
                    ].map((item, idx) => (
                      <div key={idx} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 11, borderBottom: "1px solid rgba(255,255,255,0.05)", paddingBottom: 5 }}>
                        <span>{item.label}</span>
                        <span style={{ color: item.ok ? "#10b981" : "#ef4444", fontWeight: "bold" }}>
                          {item.ok ? "✅ Ready" : "❌ Missing"}
                        </span>
                      </div>
                    ))}
                  </div>
                  <button className="erp-btn active" style={{ width: "100%", justifyContent: "center", padding: 8, background: "#FD6101", color: "#fff" }} onClick={handleRetryEmu}>
                    🔄 Retry Diagnostics
                  </button>
                </div>
              ) : !powerOn ? (
                /* Simulated Black Screen Off state */
                <div style={{ position: "absolute", inset: 0, background: "#000000", zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center", color: "#475569", fontSize: 11 }}>
                  <span>Screen Off</span>
                </div>
              ) : !apkFile ? (
                /* Placeholder: No APK uploaded */
                <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "#94a3b8", padding: 24, textAlign: "center" }}>
                  <div style={{ fontSize: 32 }}>🤖</div>
                  <div style={{ color: "#ffffff", fontWeight: 700, fontSize: 13 }}>No APK Uploaded</div>
                  <div style={{ fontSize: 11, color: "#64748b" }}>Please upload a valid .apk or .aab package using the top control bar to begin testing.</div>
                </div>
              ) : emuStatus.failed ? (
                /* Dynamic System Error Overlays */
                emuStatus.install_failed ? (
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, color: "#e2e8f0", padding: 24, textAlign: "center", background: "#090d16" }}>
                    <div style={{ fontSize: 40 }}>❌</div>
                    <div>
                      <div style={{ fontWeight: 800, fontSize: 15, color: "#ffffff", marginBottom: 6 }}>APK Installation Failed</div>
                      <div style={{ fontSize: 11, color: "#ef4444", fontWeight: "bold", marginBottom: 4 }}>Reason:</div>
                      <div style={{ fontSize: 10, color: "#94a3b8", background: "rgba(255,255,255,0.05)", padding: 8, borderRadius: 6, maxHeight: 110, overflowY: "auto", fontFamily: "monospace", textAlign: "left", whiteSpace: "pre-wrap" }}>{emuStatus.fail_reason}</div>
                    </div>
                    <div style={{ display: "flex", gap: 8, width: "100%" }}>
                      <button className="erp-btn active" style={{ flex: 1, justifyContent: "center", padding: 8, background: "#FD6101", color: "#fff" }} onClick={handleRetryEmu}>
                        🔄 Retry
                      </button>
                      <button className="erp-btn" style={{ flex: 1, justifyContent: "center", borderColor: "#64748b", color: "#94a3b8" }} onClick={() => setLogcatOpen(true)}>
                        📋 View Logs
                      </button>
                    </div>
                  </div>
                ) : emuStatus.launch_failed ? (
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, color: "#e2e8f0", padding: 24, textAlign: "center", background: "#090d16" }}>
                    <div style={{ fontSize: 40 }}>🚫</div>
                    <div>
                      <div style={{ fontWeight: 800, fontSize: 15, color: "#ffffff", marginBottom: 6 }}>Application could not be started</div>
                      <div style={{ fontSize: 11, color: "#94a3b8", lineHeight: 1.5 }}>Launch Activity not found.</div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "column", gap: 8, width: "100%" }}>
                      <button className="erp-btn active" style={{ width: "100%", justifyContent: "center", padding: 8, background: "#FD6101", color: "#fff" }} onClick={() => setLogcatOpen(true)}>
                        📋 View Android Logcat
                      </button>
                      <button className="erp-btn" style={{ width: "100%", justifyContent: "center", borderColor: "#64748b", color: "#94a3b8" }} onClick={handleRestartApp}>
                        🔄 Restart App
                      </button>
                    </div>
                  </div>
                ) : (
                  <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, color: "#e2e8f0", padding: 24, textAlign: "center", background: "#090d16" }}>
                    <div style={{ fontSize: 40 }}>⚠️</div>
                    <div>
                      <div style={{ fontWeight: 800, fontSize: 15, color: "#ffffff", marginBottom: 6 }}>Android Emulator is not available</div>
                      <div style={{ fontSize: 11, color: "#94a3b8", lineHeight: 1.5, whiteSpace: "pre-wrap" }}>Please start an Android Emulator or connect a physical Android device.</div>
                    </div>
                    <button className="erp-btn active" style={{ width: "100%", justifyContent: "center", padding: 8, background: "#FD6101", color: "#fff" }} onClick={handleRetryEmu}>
                      🔄 Retry Launch
                    </button>
                  </div>
                )
              ) : (emuStatus.status_message === "Waiting for Emulator" || emuStatus.status_message === "Installing APK" || emuStatus.status_message === "Launching Application" || (emuStatus.progress_checklist && Object.values(emuStatus.progress_checklist).some(v => v === "pending" || v === "idle"))) ? (
                /* Step-by-Step Checklist Progress UI */
                <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 20, color: "#e2e8f0", padding: 24, background: "#090d16" }}>
                  <div style={{ fontWeight: 800, fontSize: 15, color: "#ffffff", marginBottom: 8, letterSpacing: "0.5px" }}>⚙ Device Initialization Cloud</div>
                  <div style={{ display: "flex", flexDirection: "column", gap: 10, width: "100%", maxWidth: 220, textAlign: "left" }}>
                    {[
                      { label: "Uploading APK", key: "Uploading APK" },
                      { label: "Validating APK", key: "Validating APK" },
                      { label: "Starting Emulator", key: "Starting Emulator" },
                      { label: "Installing APK", key: "Installing APK" },
                      { label: "Launching Application", key: "Launching Application" },
                      { label: "Streaming Device", key: "Streaming Device" }
                    ].map(step => {
                      const status = (emuStatus.progress_checklist && emuStatus.progress_checklist[step.key]) || "idle";
                      let icon = "○";
                      let color = "#64748b";
                      if (status === "success") {
                        icon = "✔";
                        color = "#10b981";
                      } else if (status === "pending") {
                        icon = "⏳";
                        color = "#a78bfa";
                      } else if (status === "failed") {
                        icon = "❌";
                        color = "#ef4444";
                      }
                      return (
                        <div key={step.key} style={{ display: "flex", alignItems: "center", justifyContext: "space-between", fontSize: 12, color: color, fontWeight: status === "pending" ? 800 : 500 }}>
                          <span style={{ marginRight: 10, fontSize: 13 }}>{icon}</span>
                          <span>{step.label}</span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : emuStatus.status_message === "Application Crashed" ? (
                /* Crashed Overlay State */
                <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, color: "#e2e8f0", padding: 24, textAlign: "center", background: "#090d16" }}>
                  <div style={{ fontSize: 40 }}>💥</div>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 15, color: "#ffffff", marginBottom: 6 }}>Application crashed immediately after launch</div>
                    <div style={{ fontSize: 11, color: "#94a3b8", lineHeight: 1.5 }}>The app process terminated unexpectedly.</div>
                  </div>
                  <div style={{ display: "flex", gap: 8, width: "100%" }}>
                    <button className="erp-btn active" style={{ flex: 1, justifyContent: "center", padding: 8, background: "#dc2626", color: "#fff" }} onClick={handleRestartApp}>
                      🔄 Restart App
                    </button>
                    <button className="erp-btn" style={{ flex: 1, justifyContent: "center", borderColor: "#64748b", color: "#94a3b8" }} onClick={() => setLogcatOpen(true)}>
                      📋 View Crash Log
                    </button>
                  </div>
                </div>
              ) : emuStatus.status_message === "Application Closed" ? (
                /* Closed Overlay State */
                <div style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, color: "#e2e8f0", padding: 24, textAlign: "center", background: "#090d16" }}>
                  <div style={{ fontSize: 40 }}>📱</div>
                  <div>
                    <div style={{ fontWeight: 800, fontSize: 15, color: "#ffffff", marginBottom: 6 }}>Application Closed</div>
                    <div style={{ fontSize: 11, color: "#94a3b8", lineHeight: 1.5 }}>The application has exited. Ready to run.</div>
                  </div>
                  <div style={{ display: "flex", gap: 8, width: "100%" }}>
                    <button className="erp-btn active" style={{ flex: 1, justifyContent: "center", padding: 8, background: "#FD6101", color: "#fff" }} onClick={handleRestartApp}>
                      🚀 Restart App
                    </button>
                    <button className="erp-btn" style={{ flex: 1, justifyContent: "center", borderColor: "#64748b", color: "#94a3b8" }} onClick={() => setLogcatOpen(true)}>
                      📋 View Logcat
                    </button>
                  </div>
                </div>
              ) : (
                /* Direct Stream Viewport */
                <div style={{ width: "100%", height: "100%", position: "relative", display: "flex", alignItems: "center", justifyContent: "center", background: "#000" }}>
                  <img
                    src={frameSrc || `${API_BASE}/api/emulator-frame?t=${Date.now()}`}
                    alt="emulator stream"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "contain",
                      cursor: "pointer",
                      display: "block"
                    }}
                    onMouseDown={handleScreenClick}
                  />
                </div>
              )}
            </div>
          ) : (
            /* Original URL / iframe / Website simulation view */
            <>
              {url ? (
                <iframe
                  key={`${dev.id}-${slotIdx}-${iframeKey}`}
                  src={url}
                  title={`sim-${dev.id}-${slotIdx}`}
                  style={{
                    width: dW,
                    height: mob && !ls ? dH - 22 : dH,
                    border: "none",
                    display: "block",
                    transform: `scale(${s})`,
                    transformOrigin: "top left"
                  }}
                  sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-downloads allow-pointer-lock allow-modals"
                  onError={onBlocked}
                />
              ) : (
                <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, color: "#64748b", fontSize: 13, textAlign: "center", padding: 20 }}>
                  <div style={{ fontSize: 36 }}>🌐</div>
                  <div style={{ color: "#0f172a", fontWeight: 700 }}>Enter Target URL Above</div>
                  <div style={{ fontSize: 11, color: "#64748b" }}>Simulate enterprise web apps on real viewport specs</div>
                </div>
              )}
            </>
          )}

          {blocked && slotIdx === 0 && (
            <div style={{ position: "absolute", inset: 0, background: "#ffffff", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 12, padding: 20, textAlign: "center", zIndex: 15 }}>
              <div style={{ fontSize: 32 }}>🔒</div>
              <div style={{ fontSize: 14, fontWeight: 800, color: "#0f172a" }}>Embedding Blocked (X-Frame-Options)</div>
              <div style={{ fontSize: 11, color: "#64748b", lineHeight: 1.5 }}>This website restricts iframe embedding via Security Policy. Use Open in New Tab or local URLs.</div>
            </div>
          )}
        </div>

        {/* Home Indicator bar */}
        {mob && (
          <div style={{ height: padBot, width: "100%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
            <div style={{ width: Math.max(70, Math.round(100 * s)), height: 4, borderRadius: 2, background: "rgba(255,255,255,0.4)" }} />
          </div>
        )}
      </div>

      {/* Pill Badge Tag Below Frame */}
      <div style={{
        background: "#ffffff",
        border: "1px solid #e2e8f0",
        padding: "4px 12px",
        borderRadius: "20px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
        fontSize: 11,
        fontWeight: 700,
        color: "#0f172a",
        display: "flex",
        alignItems: "center",
        gap: 6
      }}>
        <span>{dev.name}</span>
        <span style={{ color: "#FD6101", fontWeight: 600 }}>({dW} × {dH} px)</span>
        {slotIdx > 0 && <span style={{ background: "#FD6101", color: "#fff", padding: "1px 6px", borderRadius: 4, fontSize: 10 }}>Slot #{slotIdx + 1}</span>}
      </div>
    </div>
  );
}

export default function MobileTesting() {
  const [dev, setDev] = useState(DEFAULT_DEV);
  const [url, setUrl] = useState("https://cbs.crmfarm.app/role-dashboard");
  const [urlIn, setUrlIn] = useState("https://cbs.crmfarm.app/role-dashboard");
  const [ifKey, setIfKey] = useState(0);
  const [land, setLand] = useState(false);
  const [zoom, setZoom] = useState(100);
  const [browser, setBrowser] = useState("Chrome");
  const [net, setNet] = useState("WiFi");
  const [theme, setTheme] = useState("system");
  const [touch, setTouch] = useState("tap");
  const [cnt, setCnt] = useState(1);
  const [sync, setSync] = useState(false);
  const [rec, setRec] = useState(false);
  const [lOpen, setLOpen] = useState(true);
  const [rOpen, setROpen] = useState(true);
  const [ltab, setLtab] = useState("library");
  const [expC, setExpC] = useState(new Set(["iphones", "android-phones"]));
  const [expB, setExpB] = useState(new Set(["iphonesApple", "android-phonesSamsung"]));
  const [srch, setSrch] = useState("");
  const [favs, setFavs] = useState(new Set(["i16pm", "ss24u", "gp9p"]));
  const [recent, setRecent] = useState([DEFAULT_DEV]);
  const [dtOpen, setDtOpen] = useState(false);
  const [dtTab, setDtTab] = useState("console");
  const [cW, setCW] = useState("");
  const [cH, setCH] = useState("");
  const [fps, setFps] = useState(60);
  const [blocked, setBlocked] = useState(false);
  const [grid, setGrid] = useState("none");

  // ── Android APK Mode State Variables ─────────────────────────────────────────
  const [simMode, setSimMode] = useState("website"); // "website", "apk"
  const [apkFile, setApkFile] = useState(null);
  const [apkInfo, setApkInfo] = useState(null);
  const [apkInstallState, setApkInstallState] = useState("idle"); // "idle", "installing", "installed", "failed"
  const [apkLaunchState, setApkLaunchState] = useState("idle"); // "idle", "launched"
  const [apkError, setApkError] = useState("");
  const [apkUrl, setApkUrl] = useState(null);

  // Screen recording states
  const [recState, setRecState] = useState("idle"); // "idle", "recording", "recorded"
  const [recDuration, setRecDuration] = useState(0);

  // Logcat bottom drawer states
  const [logcatOpen, setLogcatOpen] = useState(false);
  const [logcatTab, setLogcatTab] = useState("logcat"); // "logcat", "network", "storage", "console"
  const [apkLogs, setApkLogs] = useState([]);

  // Emulator controls states
  const [batteryLevel, setBatteryLevel] = useState(88);
  const [gpsLoc, setGpsLoc] = useState("13.0827, 80.2707"); // Default Chennai GPS
  const [powerOn, setPowerOn] = useState(true);
  const [camMock, setCamMock] = useState(false);
  const [micMock, setMicMock] = useState(false);
  const [appScreen, setAppScreen] = useState("login"); // "login", "dashboard", "details"
  const [apkCollapsibles, setApkCollapsibles] = useState({ appInfo: true, emulator: true });

  const [emuStatus, setEmuStatus] = useState({
    running: false,
    booted: false,
    failed: false,
    fail_reason: "",
    status_message: "Waiting for Emulator",
    has_frame: false,
    install_failed: false,
    launch_failed: false,
    crashed: false,
    progress_checklist: null,
    apk_details: null,
    allocated_device: null
  });

  const [activeLogTab, setActiveLogTab] = useState("logcat");
  const [tabLogsText, setTabLogsText] = useState("");

  useEffect(() => {
    if (simMode !== "apk" || !logcatOpen) return;
    let active = true;
    const fetchLogsText = async () => {
      try {
        const r = await fetch(`${API_BASE}/api/emulator-logs?tab=${activeLogTab}`);
        if (r.ok) {
          const data = await r.json();
          if (active) {
            setTabLogsText(data.logs);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchLogsText();
    const timer = setInterval(fetchLogsText, 2500);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [simMode, logcatOpen, activeLogTab, API_BASE]);

  const addApkLog = useCallback((level, tag, msg) => {
    const now = new Date();
    const ts = now.toTimeString().split(' ')[0] + '.' + String(now.getMilliseconds()).padStart(3, '0');
    setApkLogs(p => [{ ts, level, tag, msg }, ...p].slice(0, 200));
  }, []);

  const [healthCheck, setHealthCheck] = useState(null);

  // Poll status from backend
  useEffect(() => {
    let active = true;
    const poll = async () => {
      try {
        const r = await fetch(`${API_BASE}/api/mobile/status`);
        if (r.ok) {
          const data = await r.json();
          if (active) {
            setEmuStatus(data);
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    poll();
    const timer = setInterval(poll, 1500);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [API_BASE]);

  // Poll health diagnostics checklist
  useEffect(() => {
    if (simMode !== "apk") return;
    let active = true;
    const checkHealth = async () => {
      try {
        const r = await fetch(`${API_BASE}/api/mobile/health`);
        if (r.ok) {
          const data = await r.json();
          if (active) {
            const has_error = !data.android_sdk_installed || !data.adb_found || !data.emulator_image_found;
            if (has_error) {
              setHealthCheck(data);
            } else {
              setHealthCheck(null);
            }
          }
        }
      } catch (err) {
        console.error(err);
      }
    };
    checkHealth();
    const timer = setInterval(checkHealth, 5000);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [simMode, API_BASE]);

  // Poll logcat logs
  useEffect(() => {
    if (simMode !== "apk" || !logcatOpen) return;
    let active = true;
    const fetchLogs = async () => {
      try {
        const r = await fetch(`${API_BASE}/api/mobile/logcat`);
        if (r.ok && active) {
          const data = await r.json();
          if (data.logcat) {
            const lines = data.logcat.trim().split("\n");
            const newLogs = lines.map(line => {
              let level = "I";
              let tag = "System";
              let msg = line;

              const match = line.match(/([VDIWEF])\s+([A-Za-z0-9_\-\.]+)\s*:/);
              if (match) {
                level = match[1];
                tag = match[2];
                msg = line.substring(line.indexOf(match[0]) + match[0].length).trim();
              }

              const tsMatch = line.match(/\d{2}-\d{2}\s+\d{2}:\d{2}:\d{2}\.\d{3}/);
              const ts = tsMatch ? tsMatch[0].split(" ")[1] : "Logcat";

              return { ts, level, tag, msg };
            });
            setApkLogs(newLogs.reverse());
          }
        }
      } catch (err) {
        console.error(err);
      }
    };

    fetchLogs();
    const timer = setInterval(fetchLogs, 2500);
    return () => {
      active = false;
      clearInterval(timer);
    };
  }, [simMode, logcatOpen]);

  useEffect(() => {
    const handleFrameMessage = (e) => {
      if (e.data && e.data.type === "apk_log") {
        addApkLog(e.data.level || "I", e.data.tag || "App", e.data.message || "");
      }
    };
    window.addEventListener("message", handleFrameMessage);
    return () => window.removeEventListener("message", handleFrameMessage);
  }, [addApkLog]);

  useEffect(() => {
    const handleGlobalKeyDown = (e) => {
      if (simMode !== "apk" || !emuStatus.booted || emuStatus.failed) return;
      if (document.activeElement.tagName === "INPUT" || document.activeElement.tagName === "TEXTAREA") {
        return;
      }
      if (e.key === "Backspace") {
        fetch(`${API_BASE}/api/mobile/key?keycode=67`, { method: "POST" });
        addApkLog("D", "InputEvent", "Backspace key injected");
      } else if (e.key === "Enter") {
        fetch(`${API_BASE}/api/mobile/key?keycode=66`, { method: "POST" });
        addApkLog("D", "InputEvent", "Enter key injected");
      } else if (e.key.length === 1) {
        fetch(`${API_BASE}/api/mobile/text?text=${encodeURIComponent(e.key)}`, { method: "POST" });
        addApkLog("D", "InputEvent", `Key injected: "${e.key}"`);
      }
    };
    window.addEventListener("keydown", handleGlobalKeyDown);
    return () => window.removeEventListener("keydown", handleGlobalKeyDown);
  }, [simMode, emuStatus.booted, emuStatus.failed, addApkLog]);

  const triggerEmuKey = useCallback(async (keycode) => {
    try {
      await fetch(`${API_BASE}/api/mobile/key?keycode=${keycode}`, { method: "POST" });
    } catch (err) {
      console.error("Failed to inject hardware key:", err);
    }
  }, []);


  // Track actual canvas size for fit-to-canvas scaling (no scroll)
  const canvasRef = useRef(null);
  const [canvasSize, setCanvasSize] = useState({ w: 500, h: 700 });
  useEffect(() => {
    const el = canvasRef.current;
    if (!el) return;
    const ro = new ResizeObserver(entries => {
      for (const entry of entries) {
        setCanvasSize({ w: entry.contentRect.width, h: entry.contentRect.height });
      }
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  const [logs, setLogs] = useState([
    { t: "info", m: "[ERP Engine] Mobile Simulator initialized cleanly" },
    { t: "info", m: "[Device Target] iPhone 16 Pro Max • 430×932 • iOS 18 • Chrome" },
    { t: "info", m: "[Network Engine] WiFi 5G Connection Active (Latency 12ms)" },
  ]);

  useEffect(() => {
    const id = setInterval(() => setFps(Math.floor(Math.random() * 5) + 58), 2500);
    return () => clearInterval(id);
  }, []);

  // Screen recording timer hook
  useEffect(() => {
    let t = null;
    if (recState === "recording") {
      t = setInterval(() => setRecDuration(d => d + 1), 1000);
    } else {
      setRecDuration(0);
    }
    return () => clearInterval(t);
  }, [recState]);

  const srchRes = useMemo(() => {
    if (!srch.trim()) return [];
    const q = srch.toLowerCase();
    return allDevices.filter(d => d.name.toLowerCase().includes(q) || d.brand.toLowerCase().includes(q) || (d.os || "").toLowerCase().includes(q)).slice(0, 25);
  }, [srch]);

  const favDevs = useMemo(() => allDevices.filter(d => favs.has(d.id)), [favs]);

  const pick = useCallback((d) => {
    setDev(d); setLand(false); setBlocked(false); setIfKey(k => k + 1);
    setRecent(p => [d, ...p.filter(r => r.id !== d.id)].slice(0, 12));
    setLogs(p => [{ t: "info", m: `[Device Switch] ${d.name} — ${d.w}×${d.h} px — ${d.os || "OS Standard"}` }, ...p.slice(0, 30)]);
  }, []);

  const go = () => {
    let u = urlIn.trim();
    if (u && !u.startsWith("http")) u = "https://" + u;
    setUrl(u); setUrlIn(u); setBlocked(false); setIfKey(k => k + 1);
    setLogs(p => [{ t: "info", m: `[Navigation] Requesting URL: ${u}` }, ...p.slice(0, 30)]);
  };

  // ── Android APK Lifecycle & Emulator Actions ───────────────────────────────
  const handleApkUpload = useCallback(async (file) => {
    if (!file) return;
    const ext = file.name.split('.').pop().toLowerCase();
    if (ext !== 'apk' && ext !== 'aab') {
      setApkError("Invalid APK File. Please upload a valid Android APK.");
      setApkFile(null);
      setApkInfo(null);
      setApkInstallState("idle");
      setApkLaunchState("idle");
      addApkLog("E", "PackageManager", `Rejected invalid file format: .${ext}`);
      return;
    }

    setApkError("");
    setApkFile(file);
    addApkLog("I", "PackageManager", `Parsing metadata for uploaded package: ${file.name}`);

    const formData = new FormData();
    formData.append("file", file);

    try {
      addApkLog("I", "PackageManager", "Uploading and unpacking app package on local emulator device...");
      const resp = await fetch(`${API_BASE}/api/mobile/upload`, {
        method: "POST",
        body: formData
      });
      const data = await resp.json();
      if (!resp.ok) {
        throw new Error(data.error || "Failed to process APK package on backend.");
      }

      addApkLog("I", "PackageManager", `Backend unpacking success: Loaded "${data.application_name}"`);
      const info = {
        name: data.application_name,
        packageName: data.package_name,
        version: data.version,
        buildNumber: data.version_code,
        size: data.apk_size,
        minSdk: data.minimum_sdk,
        targetSdk: data.target_sdk,
        permissions: data.permissions,
        architecture: data.architecture,
        installedSize: data.apk_size,
        launchActivity: data.launcher_activity
      };

      setApkInfo(info);
      setApkUrl(`${API_BASE}/api/mobile/stream`);
      setApkInstallState("idle");
      setApkLaunchState("idle");
      addApkLog("I", "PackageManager", `Metadata successfully extracted for ${info.packageName}`);
    } catch (err) {
      console.error("[APK UPLOAD ERROR]:", err);
      setApkError(`Failed to unpack package: ${err.message}`);
      addApkLog("E", "PackageManager", `Unpacking failed: ${err.message}`);
      setApkInstallState("failed");
    }
  }, [addApkLog, API_BASE]);

  const installApk = useCallback(async () => {
    if (!apkInfo) return;
    setApkInstallState("installing");
    addApkLog("I", "PackageManager", `Installing package ${apkInfo.packageName}...`);
    try {
      const resp = await fetch(`${API_BASE}/api/mobile/install`, { method: "POST" });
      const data = await resp.json();
      if (resp.ok && data.success) {
        setApkInstallState("installed");
        addApkLog("I", "PackageManager", `Package ${apkInfo.packageName} installed successfully`);
      } else {
        setApkInstallState("failed");
        setApkError(data.error || "Installation Failed");
        addApkLog("E", "PackageManager", `Installation failed: ${data.error}`);
      }
    } catch (err) {
      setApkInstallState("failed");
      setApkError(err.message);
      addApkLog("E", "PackageManager", `Installation failed: ${err.message}`);
    }
  }, [apkInfo, addApkLog, API_BASE]);

  const uninstallApk = useCallback(async () => {
    if (!apkInfo) return;
    setApkInstallState("idle");
    setApkLaunchState("idle");
    setApkFile(null);
    setApkInfo(null);
    setApkUrl(null);
    addApkLog("I", "PackageManager", `Uninstalling package ${apkInfo.packageName}...`);
    try {
      await fetch(`${API_BASE}/api/mobile/uninstall`, { method: "POST" });
      addApkLog("I", "PackageManager", `Removed user storage, cache directory and DB files`);
    } catch (err) {
      console.error(err);
    }
  }, [apkInfo, addApkLog, API_BASE]);

  const launchApp = useCallback(async () => {
    if (apkInstallState !== "installed") return;
    setApkLaunchState("launched");
    addApkLog("I", "ActivityManager", `Starting activity: Intent { act=android.intent.action.MAIN cat=[android.intent.category.LAUNCHER] cmp=${apkInfo.packageName}/${apkInfo.launchActivity} }`);
    try {
      const resp = await fetch(`${API_BASE}/api/mobile/launch`, { method: "POST" });
      const data = await resp.json();
      if (resp.ok && data.success) {
        addApkLog("I", "WindowManager", `Focus entering window ${apkInfo.packageName}/${apkInfo.launchActivity}`);
      } else {
        addApkLog("E", "ActivityManager", `Launch failed: ${data.error}`);
      }
    } catch (err) {
      console.error(err);
    }
  }, [apkInstallState, apkInfo, addApkLog, API_BASE]);

  const restartApp = useCallback(async () => {
    if (apkLaunchState !== "launched") return;
    addApkLog("I", "ActivityManager", `Force stopping package ${apkInfo.packageName}`);
    addApkLog("I", "ActivityManager", `Restarting MainActivity...`);
    try {
      await fetch(`${API_BASE}/api/mobile/restart`, { method: "POST" });
    } catch (err) {
      console.error(err);
    }
  }, [apkLaunchState, apkInfo, addApkLog, API_BASE]);

  const clearAppData = useCallback(() => {
    addApkLog("I", "ActivityManager", `Clearing data for package com.rabbit.crm`);
    setAppScreen("login");
    addApkLog("I", "PackageManager", `Removed user storage and shared preferences`);
  }, [addApkLog]);

  const toggleFav = (id, e) => {
    e.stopPropagation();
    setFavs(p => { const n = new Set(p); n.has(id) ? n.delete(id) : n.add(id); return n; });
  };

  // Compute effective width/height (accounts for landscape rotation)
  const effW = land ? dev.h : dev.w;
  const effH = land ? dev.w : dev.h;

  const [capturing, setCapturing] = useState(false);
  const shot = useCallback(async () => {
    if (capturing) return;

    const targetUrl = simMode === "apk" ? (url || "https://cbs.crmfarm.app") : url;
    if (!targetUrl) {
      alert('Please enter a URL or launch an application to load before taking a screenshot.');
      return;
    }

    setCapturing(true);
    const modeName = simMode === "apk" ? "Android App" : "Website";
    setLogs(p => [{ t: "info", m: `[Capture] Requesting screenshot of ${dev.name} ${modeName} (${effW}×${effH}px)…` }, ...p.slice(0, 30)]);
    if (simMode === "apk") {
      addApkLog("I", "ScreenShotManager", `Taking screenshot of simulated Android Viewport (${effW}×${effH}px)...`);
    }

    try {
      const resp = await fetch(`${API_BASE}/api/mobile-screenshot`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          url: targetUrl,
          width: effW,
          height: effH,
          device_pixel_ratio: dev.dpr || 3,
          device_name: dev.name,
        }),
      });

      const data = await resp.json();

      if (!resp.ok || !data.success) {
        throw new Error(data.error || 'Screenshot API returned an error');
      }

      const link = document.createElement('a');
      const ts = new Date().toISOString().replace(/[:.]/g, '-').slice(0, 19);
      link.download = `rabbit-${simMode === "apk" ? "apk" : "simulator"}_${dev.name.replace(/\s+/g, '-')}_${ts}.png`;
      link.href = data.image;
      link.click();

      const logMsg = `[Capture] ✅ Screenshot saved: ${link.download}`;
      setLogs(p => [{ t: "info", m: logMsg }, ...p.slice(0, 30)]);
      if (simMode === "apk") {
        addApkLog("I", "ScreenShotManager", `✅ Screenshot saved successfully: ${link.download}`);
      }
    } catch (err) {
      console.error('[Capture]', err);
      setLogs(p => [{ t: "error", m: `[Capture Error] ${err.message}` }, ...p.slice(0, 30)]);
      if (simMode === "apk") {
        addApkLog("E", "ScreenShotManager", `Screenshot failed: ${err.message}`);
      }
      alert(`Screenshot failed: ${err.message}`);
    } finally {
      setCapturing(false);
    }
  }, [capturing, url, dev, effW, effH, simMode, batteryLevel, gpsLoc, camMock, addApkLog]);

  const nc = net === "Offline" ? "#ef4444" : (net === "Slow 3G" || net === "2G") ? "#f59e0b" : "#16a34a";

  const multi = useMemo(() => [
    dev,
    allDevices.find(d => d.id === "i16pm") || dev,
    allDevices.find(d => d.id === "ss24u") || dev,
    allDevices.find(d => d.id === "gp9p") || dev,
  ], [dev]);

  const frameProps = {
    landscape: land,
    zoom,
    url,
    iframeKey: ifKey,
    isMain: cnt === 1,
    onBlocked: () => setBlocked(true),
    blocked,
    canvasW: canvasSize.w,
    canvasH: canvasSize.h,
    simMode,
    apkFile,
    apkInfo,
    apkInstallState,
    apkLaunchState,
    apkError,
    apkUrl,
    batteryLevel,
    gpsLoc,
    powerOn,
    camMock,
    micMock,
    appScreen,
    setAppScreen,
    addApkLog,
    installApk,
    launchApp,
    emuStatus,
    setEmuStatus,
    setLogcatOpen,
    API_BASE,
    healthCheck
  };

  const DRow = ({ d }) => (
    <div className={`erp-dev-row${dev.id === d.id ? " active" : ""}`} onClick={() => pick(d)}>
      <span>{d.name}</span>
      <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
        <span style={{ fontSize: 10, color: "#64748b", fontWeight: 600 }}>{d.w}×{d.h}</span>
        <button
          style={{ background: "none", border: "none", cursor: "pointer", color: favs.has(d.id) ? "#f59e0b" : "#cbd5e1", fontSize: 13, padding: 0 }}
          onClick={e => toggleFav(d.id, e)}
        >
          {favs.has(d.id) ? "★" : "☆"}
        </button>
      </div>
    </div>
  );

  return (
    <div className="erp-ds">
      <style>{CSS}</style>

      {/* ── TOP CONTROL BAR ── */}
      <div className="erp-top">
        {!lOpen && (
          <button className="erp-btn" onClick={() => setLOpen(true)}>
            <span>📱 Devices</span>
          </button>
        )}

        <div className="erp-title">
          <span>Device Simulator</span>
          <span className="erp-title-badge">ERP Enterprise</span>
        </div>

        {/* Simulation Mode Selector */}
        <div style={{ display: "flex", alignItems: "center", gap: 4, background: "#f1f5f9", padding: "3px", borderRadius: "8px", border: "1px solid #cbd5e1" }}>
          <button
            className={`erp-btn${simMode === "website" ? " active" : ""}`}
            style={{ padding: "4px 8px", fontSize: 11, border: "none", boxShadow: "none" }}
            onClick={() => {
              setSimMode("website");
              addApkLog("I", "System", "Switched to Website Simulation Mode");
            }}
          >
            🌐 Website
          </button>
          <button
            className={`erp-btn${simMode === "apk" ? " active" : ""}`}
            style={{ padding: "4px 8px", fontSize: 11, border: "none", boxShadow: "none" }}
            onClick={() => {
              setSimMode("apk");
              addApkLog("I", "System", "Switched to Android App Live Mode");
            }}
          >
            🤖 Android App Live
          </button>
          <button
            className="erp-btn"
            style={{ padding: "4px 8px", fontSize: 11, border: "none", boxShadow: "none", opacity: 0.5, cursor: "not-allowed" }}
            disabled
            title="Coming Soon"
          >
            🍎 iOS App Live (Coming Soon)
          </button>
        </div>

        <div className="erp-sep" />

        {/* Conditional Input Section: Website URL vs APK Upload Zone */}
        {simMode === "website" ? (
          <div className="erp-url-box">
            <span style={{ color: "#16a34a", fontSize: 13 }}>🔒</span>
            <input
              className="erp-url-input"
              value={urlIn}
              onChange={e => setUrlIn(e.target.value)}
              onKeyDown={e => e.key === "Enter" && go()}
              placeholder="Enter web application URL…"
            />
            <button onClick={go} style={{ background: "none", border: "none", color: "#FD6101", cursor: "pointer", fontSize: 15, fontWeight: "bold" }}>→</button>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              background: "#f1f5f9",
              border: apkFile ? "1px solid #FD6101" : "2px dashed #cbd5e1",
              borderRadius: "10px",
              padding: "5px 16px",
              flex: 1,
              maxWidth: "460px",
              minWidth: "220px",
              cursor: "pointer",
              justifyContent: "center",
              position: "relative",
              transition: "all 0.2s ease"
            }}
            onDragOver={e => e.preventDefault()}
            onDrop={e => {
              e.preventDefault();
              handleApkUpload(e.dataTransfer.files[0]);
            }}
            onClick={() => document.getElementById("apk-browse-input").click()}
          >
            <input
              id="apk-browse-input"
              type="file"
              accept=".apk,.aab"
              style={{ display: "none" }}
              onChange={e => handleApkUpload(e.target.files[0])}
            />
            {apkFile ? (
              <>
                <span style={{ fontSize: 14 }}>📦</span>
                <span style={{ fontSize: 11.5, fontWeight: 700, color: "#0f172a", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {apkFile.name} ({apkInfo?.size})
                </span>
                <span style={{
                  fontSize: 10,
                  fontWeight: 800,
                  background: apkInstallState === "installed" ? "#dcfce7" : apkInstallState === "installing" ? "#fef9c3" : "#f1f5f9",
                  color: apkInstallState === "installed" ? "#15803d" : apkInstallState === "installing" ? "#854d0e" : "#475569",
                  padding: "1px 6px",
                  borderRadius: 4
                }}>
                  {apkInstallState.toUpperCase()}
                </span>
              </>
            ) : (
              <>
                <span style={{ fontSize: 14 }}>📥</span>
                <span style={{ fontSize: 11.5, fontWeight: 700, color: "#64748b" }}>
                  Drag & Drop APK here or <span style={{ color: "#FD6101", textDecoration: "underline" }}>Browse</span>
                </span>
              </>
            )}
          </div>
        )}

        <div className="erp-sep" />

        {/* Shared Rotate & Screenshot Buttons */}
        <button className="erp-btn-icon" onClick={() => setIfKey(k => k + 1)} title="Refresh Viewport">↻</button>
        <button className="erp-btn" onClick={() => { setLand(l => !l); setIfKey(k => k + 1); }} title="Rotate Orientation">
          <span>⟳ Rotate</span>
        </button>

        {/* Screen Recording Button (APK Mode only) */}
        {simMode === "apk" && (
          <button
            className={`erp-btn${recState === "recording" ? ' active' : ''}`}
            onClick={() => {
              if (recState === "idle") {
                setRecState("recording");
                addApkLog("I", "ScreenRecord", "Started simulated screen recording session");
              } else if (recState === "recording") {
                setRecState("recorded");
                addApkLog("I", "ScreenRecord", `Stopped screen recording. Duration: ${recDuration} seconds`);
              } else {
                // Download recorded file
                const mockUrl = "data:video/mp4;base64,AAAAHGZ0eXBtcDQyAAAAAG1wZDJsYnJhAAAAAGZyZWU=";
                const link = document.createElement("a");
                link.href = mockUrl;
                link.download = `rabbit-sim-record-${Date.now()}.mp4`;
                link.click();
                setRecState("idle");
                addApkLog("I", "ScreenRecord", "Downloaded MP4 recording successfully");
              }
            }}
            title="Record Screen"
          >
            <span>
              {recState === "recording" ? `🔴 Stop (${recDuration}s)` : recState === "recorded" ? "💾 Download MP4" : "⏺ Record App"}
            </span>
          </button>
        )}

        <button className={`erp-btn${capturing ? ' active' : ''}`} onClick={shot} title="Take Screenshot" disabled={capturing}>
          <span>{capturing ? '⏳ Capturing…' : '📸 Capture'}</span>
        </button>

        <div className="erp-sep" />

        {/* Multi-Device Grid Count */}
        <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          <span style={{ fontSize: 10, fontWeight: 800, color: "#64748b", marginRight: 2 }}>GRID</span>
          {[1, 2, 3, 4].map(n => (
            <button
              key={n}
              className={`erp-btn${cnt === n ? " active" : ""}`}
              style={{ padding: "4px 9px", fontSize: 11 }}
              onClick={() => setCnt(n)}
            >
              {n}
            </button>
          ))}
        </div>

        <div className="erp-sep" />

        <button className={`erp-btn${dtOpen ? " active" : ""}`} onClick={() => setDtOpen(o => !o)}>
          <span>⌥ DevTools</span>
        </button>

        {!rOpen && (
          <button className="erp-btn" style={{ marginLeft: "auto" }} onClick={() => setROpen(true)}>
            <span>Properties ◀</span>
          </button>
        )}
      </div>

      {/* ── SUB-TOOLBAR FOR ACTIVE DEVICE KPI ── */}
      <div className="erp-sub-toolbar">
        <span style={{ fontSize: 13, fontWeight: 800, color: "#FD6101" }}>{dev.name}</span>
        <span className="erp-badge purple">{effW} × {effH} px</span>
        <span className="erp-badge green">{dev.os || "Mobile OS"}</span>
        <span className="erp-badge blue">{browser}</span>
        {simMode === "apk" && emuStatus.allocated_device && (
          <span className="erp-badge orange" style={{ background: "#FD6101", color: "#fff", fontWeight: "bold" }}>
            Allocated Device: {emuStatus.allocated_device.name}, {emuStatus.allocated_device.os}, {emuStatus.allocated_device.id}
          </span>
        )}

        <div className="erp-sep" />

        <span style={{ fontSize: 10, fontWeight: 800, color: "#64748b" }}>TOUCH</span>
        {TOUCH_MODES.slice(0, 3).map(([id, lbl]) => (
          <button
            key={id}
            className={`erp-btn${touch === id ? " active" : ""}`}
            style={{ padding: "3px 8px", fontSize: 10 }}
            onClick={() => setTouch(id)}
          >
            {lbl}
          </button>
        ))}

        <div className="erp-sep" />

        <span style={{ fontSize: 10, fontWeight: 800, color: "#64748b" }}>SCALE</span>
        <input
          type="range"
          min={30}
          max={150}
          step={5}
          value={zoom}
          onChange={e => setZoom(+e.target.value)}
          style={{ width: 80, accentColor: "#FD6101" }}
        />
        <span style={{ fontSize: 12, color: "#FD6101", fontWeight: 800, minWidth: 36 }}>{zoom}%</span>

        <div className="erp-sep" />

        <span style={{ fontSize: 10, fontWeight: 800, color: "#64748b" }}>NET</span>
        <select
          className="erp-search"
          value={net}
          onChange={e => {
            const val = e.target.value;
            setNet(val);
            fetch(`${API_BASE}/api/emulator-control?param=network&value=${encodeURIComponent(val)}`, { method: "POST" })
              .catch(err => console.error(err));
            addApkLog("I", "NetworkManager", `Network profile switched to: ${val}`);
          }}
          style={{ padding: "3px 8px", fontSize: 11, borderRadius: 6, border: "1px solid #cbd5e1", outline: "none" }}
        >
          {NETWORKS.map(n => <option key={n}>{n}</option>)}
        </select>

        {simMode === "apk" && (
          <>
            <div className="erp-sep" />
            <span style={{ fontSize: 10, fontWeight: 800, color: "#64748b" }}>APK</span>
            <button
              className="erp-btn"
              style={{ padding: "3px 8px", fontSize: 10 }}
              onClick={installApk}
              disabled={!apkFile || apkInstallState === "installing" || apkInstallState === "installed"}
            >
              📥 Install APK
            </button>
            <button
              className="erp-btn"
              style={{ padding: "3px 8px", fontSize: 10 }}
              onClick={() => {
                addApkLog("I", "PackageManager", "Initiating reinstall process...");
                installApk();
              }}
              disabled={!apkFile}
            >
              🔄 Reinstall
            </button>
            <button
              className="erp-btn"
              style={{ padding: "3px 8px", fontSize: 10 }}
              onClick={restartApp}
              disabled={apkLaunchState !== "launched"}
            >
              ⚡ Restart App
            </button>
            <button
              className="erp-btn"
              style={{ padding: "3px 8px", fontSize: 10 }}
              onClick={clearAppData}
              disabled={!apkFile}
            >
              🧹 Clear App Data
            </button>
            <button
              className="erp-btn"
              style={{ padding: "3px 8px", fontSize: 10, color: "#ef4444" }}
              onClick={uninstallApk}
              disabled={!apkFile}
            >
              🗑 Uninstall
            </button>
            <button
              className={`erp-btn${logcatOpen ? " active" : ""}`}
              style={{ padding: "3px 8px", fontSize: 10 }}
              onClick={() => setLogcatOpen(o => !o)}
            >
              📋 View Logcat
            </button>
          </>
        )}
      </div>

      {/* ── MAIN WORKSPACE ── */}
      <div className="erp-main">
        {/* LEFT DEVICE LIBRARY PANEL */}
        <div className={`erp-left-panel${lOpen ? "" : " closed"}`}>
          <div className="erp-panel-title">
            <span>📱 Device Library</span>
            <button className="erp-btn-icon" style={{ padding: "2px 6px", fontSize: 11 }} onClick={() => setLOpen(false)}>◀</button>
          </div>

          <div className="erp-tabs">
            {[["library", "Library"], ["favorites", "★ Favs"], ["recent", "🕒 Recent"]].map(([id, lbl]) => (
              <button key={id} className={`erp-tab${ltab === id ? " active" : ""}`} onClick={() => setLtab(id)}>{lbl}</button>
            ))}
          </div>

          <div className="erp-search">
            <input placeholder="🔍 Search devices…" value={srch} onChange={e => setSrch(e.target.value)} />
          </div>

          <div className="erp-scroll">
            {srch.trim() ? (
              srchRes.length === 0
                ? <div style={{ padding: "20px 14px", color: "#64748b", fontSize: 12, textAlign: "center" }}>No devices found</div>
                : srchRes.map(d => <DRow key={d.id} d={d} />)
            ) : ltab === "favorites" ? (
              favDevs.length === 0
                ? <div style={{ padding: "20px 14px", color: "#64748b", fontSize: 12, textAlign: "center" }}>Star devices to access here</div>
                : favDevs.map(d => <DRow key={d.id} d={d} />)
            ) : ltab === "recent" ? (
              recent.length === 0
                ? <div style={{ padding: "20px 14px", color: "#64748b", fontSize: 12, textAlign: "center" }}>No recent history</div>
                : recent.map((d, i) => (
                  <div key={`rc-${d.id}-${i}`} className={`erp-dev-row${dev.id === d.id ? " active" : ""}`} onClick={() => pick(d)}>
                    <span>{d.name}</span>
                    <span style={{ fontSize: 10, color: "#64748b" }}>{d.w}×{d.h}</span>
                  </div>
                ))
            ) : (
              Object.entries(DEVICE_DB).map(([cId, cat]) => {
                const co = expC.has(cId);
                return (
                  <div key={cId}>
                    <div className={`erp-cat${co ? " open" : ""}`} onClick={() => setExpC(p => { const n = new Set(p); co ? n.delete(cId) : n.add(cId); return n; })}>
                      <span>{co ? "▾" : "▸"}</span>
                      <span style={{ fontSize: 14 }}>{cat.icon}</span>
                      <span>{cat.label}</span>
                    </div>
                    {co && Object.entries(cat.brands).map(([brand, devs]) => {
                      const bk = cId + brand, bo = expB.has(bk);
                      return (
                        <div key={brand}>
                          <div className={`erp-brand${bo ? " open" : ""}`} onClick={() => setExpB(p => { const n = new Set(p); bo ? n.delete(bk) : n.add(bk); return n; })}>
                            <span>{bo ? "▾" : "▸"}</span>
                            <span>{brand}</span>
                            <span style={{ marginLeft: "auto", fontSize: 10, color: "#94a3b8" }}>{devs.length}</span>
                          </div>
                          {bo && devs.map(d => <DRow key={d.id} d={{ ...d, brand, category: cId }} />)}
                        </div>
                      );
                    })}
                  </div>
                );
              })
            )}
          </div>
        </div>

        {/* CENTER VIEWPORT CANVAS */}
        <div className="erp-center">
          <div className="erp-canvas" ref={canvasRef}>
            {cnt === 1
              ? <DeviceFrame {...frameProps} dev={dev} slotIdx={0} />
              : <div style={{ display: "flex", gap: 24, flexWrap: "wrap", justifyContent: "center" }}>
                {Array.from({ length: cnt }).map((_, i) => (
                  <DeviceFrame key={i} {...frameProps} dev={multi[i] || dev} slotIdx={i} isMain={false} />
                ))}
              </div>
            }
          </div>

          {/* DEVTOOLS DRAWER */}
          {dtOpen && (
            <div className="erp-devtools">
              <div className="erp-dt-header">
                {[["console", "Console Logs"], ["network", "Network Packets"], ["elements", "DOM Inspector"], ["storage", "Storage Isolation"]].map(([id, lbl]) => (
                  <button key={id} className={`erp-dt-tab${dtTab === id ? " active" : ""}`} onClick={() => setDtTab(id)}>{lbl}</button>
                ))}
                <button style={{ marginLeft: "auto", background: "none", border: "none", color: "#64748b", cursor: "pointer", fontSize: 14 }} onClick={() => setDtOpen(false)}>✕</button>
              </div>
              <div className="erp-dt-content">
                {dtTab === "console" && logs.map((l, i) => (
                  <div key={i} style={{ color: l.t === "error" ? "#f87171" : l.t === "warn" ? "#fbbf24" : "#34d399", marginBottom: 4 }}>{l.m}</div>
                ))}
                {dtTab === "network" && <div>Network Simulation: <span style={{ color: nc }}>{net}</span> — Ping: 14ms — Bandwidth: Unlimited</div>}
                {dtTab === "elements" && <div>&lt;iframe src="{url}" viewport="{effW}×{effH}px" dpr="{dev.dpr || 1}x" /&gt;</div>}
                {dtTab === "storage" && <div>LocalStorage & SessionStorage scoped to simulated viewport instance.</div>}
              </div>
            </div>
          )}

          {/* LOGCAT BOTTOM DRAWER (APK Mode only) */}
          {simMode === "apk" && logcatOpen && (
            <div className="erp-devtools" style={{ height: "240px", borderTop: "2px solid #FD6101" }}>
              <div className="erp-dt-header" style={{ display: "flex", alignItems: "center", background: "#f8fafc", padding: "0 12px", borderBottom: "1px solid #e2e8f0", overflowX: "auto" }}>
                <span style={{ fontSize: 11, fontWeight: 800, color: "#FD6101", marginRight: 16, whiteSpace: "nowrap" }}>📋 Android Logs</span>
                {[
                  ["install", "Installation Logs"],
                  ["adb", "ADB Logs"],
                  ["logcat", "Logcat"],
                  ["crash", "Crash Logs"],
                  ["stream", "Streaming Logs"],
                  ["network", "Network Logs"],
                  ["emulator", "Emulator Logs"]
                ].map(([id, lbl]) => (
                  <button
                    key={id}
                    className={`erp-dt-tab${activeLogTab === id ? " active" : ""}`}
                    onClick={() => setActiveLogTab(id)}
                    style={{ background: "none", border: "none", padding: "8px 12px", fontSize: 11, cursor: "pointer", fontWeight: 700, borderBottom: activeLogTab === id ? "2px solid #FD6101" : "2px solid transparent", color: activeLogTab === id ? "#FD6101" : "#64748b", whiteSpace: "nowrap" }}
                  >
                    {lbl}
                  </button>
                ))}
                <button style={{ marginLeft: "auto", background: "none", border: "none", color: "#64748b", cursor: "pointer", fontSize: 14 }} onClick={() => setLogcatOpen(false)}>✕</button>
              </div>
              <div className="erp-dt-content" style={{ flex: 1, overflowY: "auto", padding: "12px 16px", background: "#0f172a", color: "#34d399", fontFamily: "monospace", fontSize: 11, whiteSpace: "pre-wrap" }}>
                {tabLogsText || "No logs captured in this tab yet."}
              </div>
            </div>
          )}
        </div>

        {/* RIGHT PROPERTY INSPECTOR PANEL */}
        <div className={`erp-right-panel${rOpen ? "" : " closed"}`}>
          <div className="erp-panel-title">
            <span>⚙ ERP Inspection</span>
            <button className="erp-btn-icon" style={{ padding: "2px 6px", fontSize: 11 }} onClick={() => setROpen(false)}>▶</button>
          </div>

          <div className="erp-scroll">
            <div className="erp-section-title">Hardware Specifications</div>
            {[
              ["Brand", dev.brand || "Standard"],
              ["Model", dev.name],
              ["OS Platform", dev.os || "Android / iOS"],
              ["Browser", browser],
              ["Viewport Width", effW + " px"],
              ["Viewport Height", effH + " px"],
              ["Pixel Density", (dev.dpr || 1) + "x PPI"],
              ["Refresh Rate", (dev.hz || 60) + " Hz"],
              ["Orientation", land ? "Landscape" : "Portrait"],
              ["Touch Input", "Multi-Touch"],
              ["Foldable", dev.fold ? "Yes" : "No"]
            ].map(([l, v]) => (
              <div className="erp-prop-row" key={l}>
                <span className="erp-prop-label">{l}</span>
                <span className="erp-prop-val">{v}</span>
              </div>
            ))}

            <div className="erp-section-title">Orientation Control</div>
            <div style={{ padding: "8px 14px", display: "flex", gap: 8 }}>
              <button className={`erp-btn${!land ? " active" : ""}`} style={{ flex: 1, justifyContent: "center" }} onClick={() => { setLand(false); setIfKey(k => k + 1); }}>
                ↕ Portrait
              </button>
              <button className={`erp-btn${land ? " active" : ""}`} style={{ flex: 1, justifyContent: "center" }} onClick={() => { setLand(true); setIfKey(k => k + 1); }}>
                ↔ Landscape
              </button>
            </div>

            <div className="erp-section-title">Scale & Zoom</div>
            <div style={{ padding: "8px 14px" }}>
              <div style={{ display: "flex", gap: 4 }}>
                {[50, 75, 100, 125].map(z => (
                  <button key={z} className={`erp-btn${zoom === z ? " active" : ""}`} style={{ padding: "4px 8px", fontSize: 11, flex: 1, justifyContent: "center" }} onClick={() => setZoom(z)}>
                    {z}%
                  </button>
                ))}
              </div>
            </div>

            <div className="erp-section-title">Width Presets</div>
            <div style={{ padding: "8px 14px" }}>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 4, marginBottom: 10 }}>
                {SZ_PRESETS.map(sz => (
                  <button
                    key={sz}
                    className={`erp-btn${effW === sz ? " active" : ""}`}
                    style={{ padding: "3px 8px", fontSize: 11 }}
                    onClick={() => {
                      const h = sz <= 430 ? Math.round(sz * 2.16) : sz <= 1024 ? Math.round(sz * 1.33) : Math.round(sz * 0.5625);
                      pick({ ...dev, id: "custom", name: `Custom ${sz}×${h}`, w: sz, h, type: sz <= 430 ? "mobile" : sz <= 1024 ? "tablet" : "laptop" });
                    }}
                  >
                    {sz}
                  </button>
                ))}
              </div>

              <div style={{ display: "flex", gap: 6, alignItems: "center" }}>
                <input className="erp-search" placeholder="Width" value={cW} onChange={e => setCW(e.target.value)} style={{ width: 65, padding: "5px 8px" }} />
                <span style={{ color: "#94a3b8", fontSize: 12 }}>×</span>
                <input className="erp-search" placeholder="Height" value={cH} onChange={e => setCH(e.target.value)} style={{ width: 65, padding: "5px 8px" }} />
                <button className="erp-btn" style={{ padding: "5px 10px", fontSize: 11 }} onClick={() => { const w = parseInt(cW), h = parseInt(cH); if (w > 0 && h > 0) pick({ ...dev, id: "custom", name: `Custom ${w}×${h}`, w, h }); }}>
                  Apply
                </button>
              </div>
            </div>

            <div className="erp-section-title">ERP Actions</div>
            <div style={{ padding: "8px 14px 16px", display: "flex", flexDirection: "column", gap: 8 }}>
              <button className={`erp-btn${capturing ? ' active' : ''}`} style={{ justifyContent: "center" }} onClick={shot} disabled={capturing}>{capturing ? '⏳ Capturing…' : '📸 Capture Screenshot'}</button>
              <button className={`erp-btn${rec ? " active" : ""}`} style={{ justifyContent: "center" }} onClick={() => setRec(r => !r)}>
                {rec ? "🔴 Stop Recording" : "⏺ Start Session Record"}
              </button>
            </div>

            {simMode === "apk" && (
              <>
                {/* ── APK APPLICATION INFORMATION ── */}
                <div
                  className="erp-section-title"
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", paddingBottom: 6 }}
                  onClick={() => setApkCollapsibles(p => ({ ...p, appInfo: !p.appInfo }))}
                >
                  <span>📦 Application Info</span>
                  <span style={{ fontSize: 10 }}>{apkCollapsibles.appInfo ? "▼" : "▶"}</span>
                </div>
                {apkCollapsibles.appInfo && (
                  <div style={{ padding: "4px 0" }}>
                    {[
                      ["App Name", emuStatus.apk_details?.AppName || "None"],
                      ["Package Name", emuStatus.apk_details?.PackageName || "None"],
                      ["Version", emuStatus.apk_details?.Version || "None"],
                      ["Build Number", emuStatus.apk_details?.VersionCode || "None"],
                      ["Min SDK", emuStatus.apk_details?.MinSDK || "None"],
                      ["Target SDK", emuStatus.apk_details?.TargetSDK || "None"],
                      ["ABI", emuStatus.apk_details?.ABI || "None"],
                      ["Architecture", emuStatus.apk_details?.Architecture || "None"],
                      ["Icon Path", emuStatus.apk_details?.Icon || "None"],
                      ["Signing Info", emuStatus.apk_details?.SigningInfo || "None"],
                      ["APK Size", emuStatus.apk_details?.Size || "None"],
                      ["Permissions", (emuStatus.apk_details?.Permissions || []).join(", ") || "None"]
                    ].map(([l, v]) => (
                      <div className="erp-prop-row" key={l}>
                        <span className="erp-prop-label">{l}</span>
                        <span className="erp-prop-val" style={{ maxWidth: 140, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={v}>{v}</span>
                      </div>
                    ))}
                  </div>
                )}

                {/* ── APK EMULATOR CONTROLS ── */}
                <div
                  className="erp-section-title"
                  style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer", paddingBottom: 6 }}
                  onClick={() => setApkCollapsibles(p => ({ ...p, emulator: !p.emulator }))}
                >
                  <span>🎮 Emulator Controls</span>
                  <span style={{ fontSize: 10 }}>{apkCollapsibles.emulator ? "▼" : "▶"}</span>
                </div>
                {apkCollapsibles.emulator && (
                  <div style={{ padding: "8px 14px", display: "flex", flexDirection: "column", gap: 10 }}>
                    {/* First row of controls: Power, Home, Back */}
                    <div style={{ display: "flex", gap: 6 }}>
                      <button
                        className={`erp-btn${!powerOn ? " active" : ""}`}
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          setPowerOn(p => !p);
                          fetch(`${API_BASE}/api/emulator-hardware?key=power`, { method: "POST" })
                            .catch(err => console.error(err));
                          addApkLog("D", "PowerManager", `Power button pressed. Screen turned ${powerOn ? "OFF" : "ON"}`);
                        }}
                        title="Power Toggle"
                      >
                        🔌 Power
                      </button>
                      <button
                        className="erp-btn"
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          fetch(`${API_BASE}/api/emulator-hardware?key=home`, { method: "POST" })
                            .catch(err => console.error(err));
                          addApkLog("I", "WindowManager", "Home key event triggered. Returning to application entry page.");
                        }}
                        title="Home"
                      >
                        🏠 Home
                      </button>
                      <button
                        className="erp-btn"
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          fetch(`${API_BASE}/api/emulator-hardware?key=back`, { method: "POST" })
                            .catch(err => console.error(err));
                          addApkLog("I", "WindowManager", "Back key event triggered. Navigating back in activity stack.");
                        }}
                        title="Back"
                      >
                        ◀ Back
                      </button>
                    </div>

                    {/* Second row of controls: Recent, Vol Up, Vol Down */}
                    <div style={{ display: "flex", gap: 6 }}>
                      <button
                        className="erp-btn"
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          fetch(`${API_BASE}/api/emulator-hardware?key=recent`, { method: "POST" })
                            .catch(err => console.error(err));
                          addApkLog("D", "WindowManager", "Recent Apps overview requested");
                        }}
                        title="Recent Apps"
                      >
                        ⬜ Recent
                      </button>
                      <button
                        className="erp-btn"
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          fetch(`${API_BASE}/api/emulator-hardware?key=volume_up`, { method: "POST" })
                            .catch(err => console.error(err));
                          addApkLog("D", "AudioManager", "Volume increased.");
                        }}
                        title="Volume Up"
                      >
                        🔊 Vol +
                      </button>
                      <button
                        className="erp-btn"
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          fetch(`${API_BASE}/api/emulator-hardware?key=volume_down`, { method: "POST" })
                            .catch(err => console.error(err));
                          addApkLog("D", "AudioManager", "Volume decreased.");
                        }}
                        title="Volume Down"
                      >
                        🔉 Vol -
                      </button>
                    </div>

                    {/* Third row: GPS, Rotate */}
                    <div style={{ display: "flex", gap: 6 }}>
                      <button
                        className="erp-btn"
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          const newGps = prompt("Set Mock GPS Coordinate (latitude, longitude):", gpsLoc);
                          if (newGps) {
                            setGpsLoc(newGps);
                            fetch(`${API_BASE}/api/emulator-control?param=gps&value=${encodeURIComponent(newGps)}`, { method: "POST" })
                              .catch(err => console.error(err));
                            addApkLog("I", "GpsLocationProvider", `GPS Location mock updated to: ${newGps}`);
                          }
                        }}
                        title="Set GPS Location"
                      >
                        📍 GPS
                      </button>
                      <button
                        className="erp-btn"
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          setLand(l => !l);
                          addApkLog("D", "OrientationListener", `Orientation rotation sensor toggled`);
                        }}
                        title="Rotate Emulator Screen"
                      >
                        🔄 Rotate
                      </button>
                    </div>

                    {/* Fourth row: Camera mock, Mic mock */}
                    <div style={{ display: "flex", gap: 6 }}>
                      <button
                        className={`erp-btn${camMock ? " active" : ""}`}
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          setCamMock(c => !c);
                          addApkLog("D", "CameraMock", `Mock camera input state: ${!camMock ? "ACTIVE" : "INACTIVE"}`);
                        }}
                        title="Mock Camera Sensor"
                      >
                        📷 Camera
                      </button>
                      <button
                        className={`erp-btn${micMock ? " active" : ""}`}
                        style={{ flex: 1, justifyContent: "center", padding: "5px 2px", fontSize: 11 }}
                        onClick={() => {
                          setMicMock(m => !m);
                          addApkLog("D", "AudioMock", `Mock microphone state: ${!micMock ? "ACTIVE" : "INACTIVE"}`);
                        }}
                        title="Mock Microphone Sensor"
                      >
                        🎙 Mic
                      </button>
                    </div>

                    {/* Battery Level control */}
                    <div style={{ marginTop: 4 }}>
                      <div style={{ display: "flex", justifyContent: "space-between", fontSize: 10, fontWeight: 700, color: "#64748b", marginBottom: 4 }}>
                        <span>⚡ Battery Level</span>
                        <span>{batteryLevel}%</span>
                      </div>
                      <input
                        type="range"
                        min={0}
                        max={100}
                        value={batteryLevel}
                        onChange={e => {
                          const lvl = e.target.value;
                          setBatteryLevel(+lvl);
                          fetch(`${API_BASE}/api/emulator-control?param=battery&value=${lvl}`, { method: "POST" })
                            .catch(err => console.error(err));
                          addApkLog("D", "BatteryService", `Battery percentage updated: ${lvl}%`);
                        }}
                        style={{ width: "100%", accentColor: "#FD6101" }}
                      />
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* ── ERP STATUS FOOTER ── */}
      <div className="erp-status-bar">
        <div className="erp-status-item">
          <div className="erp-status-dot" style={{ background: nc }} />
          <span>Network: {net}</span>
        </div>
        <div className="erp-sep" />
        <div className="erp-status-item">📱 Active: {dev.name}</div>
        <div className="erp-sep" />
        <div className="erp-status-item">📐 Res: {effW} × {effH} px</div>
        <div className="erp-sep" />
        <div className="erp-status-item">⚡ Engine: {fps} FPS</div>
        <div className="erp-sep" />
        <div className="erp-status-item">🖥 Browser: {browser}</div>
        <div style={{ marginLeft: "auto", color: "#FD6101", fontWeight: 700 }}>
          Qintra Enterprise Mobile Testing Engine
        </div>
      </div>
    </div>
  );
}

